import { System } from '../../shared-components/System';

export class Team {
    Id: number;
    Name: string;
    Details: string;
    Staff: string[];
    Entry = new Date(System.junkDateString);
    Exit = new Date(System.junkDateString);
    Comment: string;
    Active: boolean;
    StudentIds: string;
}